import React, { Component } from 'react';
import PropTypes from 'prop-types';

import RadioButton from './RadioButton';

class RadioGroup extends Component {
    handleChange = (value, event) => {
        if (this.props.onChange) this.props.onChange(value, event);
    };

    renderRadioButtons() {
        return React.Children.map(this.props.children, (child) => (
            RadioButton !== child.type
                ? child
                : React.cloneElement(child, {
                    checked: child.props.value === this.props.value,
                    disabled: this.props.disabled || child.props.disabled,
                    onChange: this.handleChange.bind(this, child.props.value)
                })
        ));
    }

    render() {
        return (
            <div data-sdk="radio-group" className={this.props.className}>
                {this.renderRadioButtons()}
            </div>
        );
    }
}

RadioGroup.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.string
};

RadioGroup.defaultProps = {
    className: '',
    disabled: false
};

export default RadioGroup;
